module.exports = __webpack_public_path__ + "img/variables-estrategicas.0164a951.png";